import {
  PAYMENT_METHODS_LOAD,
  PAYMENT_METHODS_CLEAR,
  PAYMENT_METHODS_ERROR,
  SET_SELECTED_PAYMENT_METHOD,
} from "./constant";

export const setPaymentMethods = (paymentMethods) => ({
  type: PAYMENT_METHODS_LOAD,
  paymentMethods,
});

export const clearPaymentMethods = () => ({
  type: PAYMENT_METHODS_CLEAR,
});

export const setErrorMessage = (message) => ({
  type: PAYMENT_METHODS_ERROR,
  message,
});

export const setSelectedPaymentMethod = (method) => ({
  type: SET_SELECTED_PAYMENT_METHOD,
  method,
});
